import { Box, Divider, Grid } from "@mui/material";
import { MenusProps } from "../"
import { escurecerCor } from "../../../../helpers/manipulacaoCores"
import { colors } from "../../bannerColors"
import { useNavigate } from "react-router-dom";
import { useModalStateContext } from "../../../../contexts/ModalStateContext";
import TemplateDashboardComOpcoes from "../../Templates/TemplateDashboardComOpcoes";
import SettingsIcon from '@mui/icons-material/Settings';
import TemplateOpcoes from "../../Templates/TemplateOpcoes";
import AddIcon from "@mui/icons-material/Add";
import ListOutlinedIcon from "@mui/icons-material/ListOutlined";
import { usePermission } from "../../../PermissionGuard";
import MoveDownOutlinedIcon from '@mui/icons-material/MoveDownOutlined';

export default function EstoqueMenu({ type }: MenusProps) {

  const navigate = useNavigate();

  const color = colors[type] || "#1E2E6B"
  const textColor = escurecerCor(color)

  const handleRedirect = (path: string) => {
    navigate(`/estoque/${path}`)
  }

  const { handleToggleModal } = useModalStateContext()

  return (
    <Box>
      <Grid container spacing={2}>
        <TemplateDashboardComOpcoes
          {...{ type }}
          color={textColor}
          items={[
            {
              label: "Configurações",
              icon: <SettingsIcon fontSize="inherit" />,
              action: () => handleRedirect('configuracoes'),
              disabled: !usePermission('estoque.configuracoes')
            }
          ]}
        />

        <Divider orientation="vertical" sx={{ border: '1px solid', borderColor: 'divider', }} flexItem />

        <Grid container size={{md: 2.4}} spacing={2} alignSelf="flex-start">
          <TemplateOpcoes
            title="Produtos"
            color={textColor}
            items={[
              {
                label: "Incluir produto",
                icon: <AddIcon fontSize="inherit" />,
                action: () => handleToggleModal('estoque', 'cadastrarProduto', true),
                disabled: !usePermission('estoque.incluir-produto'),
              },
              {
                label: "Listar todos",
                icon: <ListOutlinedIcon fontSize="inherit" />,
                action: () => handleRedirect("produtos/listar-todos"),
                disabled: !usePermission("estoque.listar-produtos"),
              },
              {
                 label: "Categorias",
                 icon: <ListOutlinedIcon fontSize="inherit" />,
                 action: () => handleToggleModal('estoque', 'listarCategorias', true),
                 disabled: !usePermission("estoque.listar-categorias"),
              },
            ]}
          />

          <TemplateOpcoes
            title="Transportadores"
            color={textColor}
            items={[
              {
                label: "Criar transportador",
                icon: <AddIcon fontSize="inherit" />,
                action: () => { },
                disabled: true,
              },
              {
                label: "Listar todos",
                icon: <AddIcon fontSize="inherit" />,
                action: () => { },
                disabled: true,
              }
            ]}
          />
        </Grid>
        <Grid container size={{md: 2.4}} spacing={2} alignSelf="flex-start">
          <TemplateOpcoes
            title="Entrada de produtos"
            color={textColor}
            items={[
              {
                label: "Recebimento de mercadorias",
                icon: <AddIcon fontSize="inherit" />,
                action: () => handleToggleModal('estoque', 'entradaProdutosregistrarRecebimento', true),
                disabled: !usePermission("estoque.entrada-produtos.registrar-recebimento"),
              },
              {
                label: "Entrada por transferência",
                icon: <AddIcon fontSize="inherit" />,
                action: () => { },
                disabled: true,
              },
              {
                label: "Histórico de entradas",
                icon: <ListOutlinedIcon fontSize="inherit" />,
                action: () => handleRedirect("entrada-produtos/historico-entradas"),
                disabled: !usePermission("estoque.entrada-produtos.historico-entradas"),
              },
            ]}
          />

          <TemplateOpcoes
            title="Suprimento"
            color={textColor}
            items={[
              {
                label: "Iniciar solicitação",
                icon: <AddIcon fontSize="inherit" />,
                action: () => { },
                disabled: true,
              },
              {
                label: "Listar todas",
                icon: <AddIcon fontSize="inherit" />,
                action: () => { },
                disabled: true,
              }
            ]}
          />
        </Grid>
        <Grid container size={{md: 2.4}} spacing={2} alignSelf="flex-start">
          <TemplateOpcoes
            title="Compras"
            color={textColor}
            items={[
              {
                label: "Iniciar solicitação",
                icon: <AddIcon fontSize="inherit" />,
                action: () => handleToggleModal('estoque', 'solicitarCompraProduto', true),
                disabled: !usePermission("estoque.solicitar-compra-produto"),
              },
              {
                label: "Listar solicitações",
                icon: <ListOutlinedIcon fontSize="inherit" />,
                action: () => handleRedirect("compras/listar-solicitacoes"),
                  disabled: !usePermission("estoque.listar-solicitacoes")
              },
            {
                label: "Listar OC´s",
                icon: <ListOutlinedIcon fontSize="inherit" />,
                action: () => handleRedirect("compras/listar-ocs"),
                disabled: !usePermission("estoque.listar-ordens-compra")
            },
            ]}
          />

          <TemplateOpcoes
            title="Ressuprimento"
            color={textColor}
            items={[
              {
                label: "Iniciar solicitação",
                icon: <AddIcon fontSize="inherit" />,
                action: () => handleToggleModal('estoque', 'solicitarRessuprimento', true),
                disabled: !usePermission("estoque.ressuprimento"),
              },
              {
                label: "Listar todas",
                icon: <AddIcon fontSize="inherit" />,
                action: () => { },
                disabled: true,
              },
              {
                label: "Expedição pedidos",
                icon: <MoveDownOutlinedIcon fontSize="inherit" />,
                action: () => handleRedirect("ressuprimento/expedicao-pedidos"),
                disabled: !usePermission("estoque.expedicao-pedidos"),
              }
            ]}
          />
        </Grid>
        <Grid container size={{md: 2.3}} spacing={2} alignSelf="flex-start">
          <TemplateOpcoes
            title="Fornecedores"
            color={textColor}
            items={[
              {
                label: "Criar fornecedor",
                icon: <AddIcon fontSize="inherit" />,
                action: () => { },
                disabled: true,
              },
              {
                label: "Listar todos",
                icon: <AddIcon fontSize="inherit" />,
                action: () => { },
                disabled: true,
              }
            ]}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

